function SideNavLinkLoadingIndicator(): JSX.Element {
  return <div className="flex flex-col justify-center text-center items-center w-full px-5 py-3">
    <div className="w-[20px] h-[20px]  bg-dropDownBorder rounded-full animate-pulse my-2" />
    <div className="w-full bg-dropDownBorder p-1.5 rounded-full" />
  </div>
}

export default SideNavLinkLoadingIndicator